import { AvField, AvForm } from 'availity-reactstrap-validation'
import { useEffect, useState } from 'react'

const TicketAzureId = ({ isEditMode, data, setUpdatedData }) => {
  const [value, setValue] = useState(data?.ticket?.azure_id)

  useEffect(() => {
    setValue(data?.ticket?.azure_id)
  }, [data?.ticket?.azure_id])
  if (!isEditMode) return <div className='subtitle1 text-muted'>{data?.ticket?.azure_id}</div>
  return (
    <AvForm>
      <AvField
        name='azure_id'
        value={value}
        className='subtitle1'
        onChange={(e) => {
          setValue(e.target.value)
          setUpdatedData((data) => {
            return {
              ...data,
              ['azure_id']: e.target.value,
            }
          })
        }}></AvField>
    </AvForm>
  )
}

export default TicketAzureId
